import { Link } from 'react-router-dom';
import './alertNavigation.css';

const sections = [
  { id: 'devices', to: '/sensors', label: 'Enheder og dækning' },
  { id: 'incidents', to: '/monitoring/unified', label: 'Hændelser' },
  { id: 'anomalies', to: '/monitoring/anomalies', label: 'Afvigelser' },
  { id: 'rules', to: '/monitoring/unified/rules', label: 'Fælles regler' },
  { id: 'legacy', to: '/monitoring/legacy', label: 'Ældre overvågning' },
] as const;

export default function AlertNavigation({ active }: { active: typeof sections[number]['id'] }) {
  return (
    <nav className="alert-navigation" aria-label="Alarmoverblik">
      {sections.map(section => (
        <Link key={section.id} to={section.to} aria-current={section.id === active ? 'page' : undefined}>
          {section.label}
        </Link>
      ))}
    </nav>
  );
}
